import api from "./client";

export async function getSiteSettings() {
  const { data } = await api.get("/api/settings");
  return data.data;
}

// Public settings are requested by several components on first paint
// (accent colour, hero video). Share one in-flight request per page load.
let settingsPromise = null;

export function getSiteSettingsCached() {
  if (!settingsPromise) {
    settingsPromise = getSiteSettings().catch((err) => {
      settingsPromise = null;
      throw err;
    });
  }
  return settingsPromise;
}

export function invalidateSiteSettingsCache() {
  settingsPromise = null;
}

export async function updateAccentColor(accentColor) {
  const { data } = await api.put("/api/admin/settings/accent", { accentColor });
  return data.data;
}

export async function updateAtelierGallery(images) {
  const { data } = await api.put("/api/admin/settings/atelier-gallery", { images });
  return data.data;
}

export async function updateShippingSettings(payload) {
  const { data } = await api.put("/api/admin/settings/shipping", payload);
  return data.data;
}

/* ── Hero video ── */

export async function getHeroVideo() {
  const { data } = await api.get("/api/admin/settings/hero-video");
  return data.data; // { url, isDefault, sizeBytes, uploadedAt, limits }
}

export async function uploadHeroVideo(file, onProgress) {
  const formData = new FormData();
  formData.append("video", file);
  const { data } = await api.put("/api/admin/settings/hero-video", formData, {
    headers: { "Content-Type": "multipart/form-data" },
    // server may re-encode the clip after the upload finishes
    timeout: 10 * 60 * 1000,
    onUploadProgress: (e) => {
      if (onProgress && e.total) {
        onProgress(Math.min(100, Math.round((e.loaded / e.total) * 100)));
      }
    },
  });
  invalidateSiteSettingsCache();
  return data.data;
}

// { overlay?: 0-100, mobilePosition?: "left" | "center" | "right" }
export async function updateHeroAppearance(payload) {
  const { data } = await api.put("/api/admin/settings/hero", payload);
  invalidateSiteSettingsCache();
  return data.data; // { hero }
}

export async function deleteHeroVideo() {
  const { data } = await api.delete("/api/admin/settings/hero-video");
  invalidateSiteSettingsCache();
  return data.data;
}
